import React from "react";
import { UsersFacadeProvider } from "./facades/Users.facade";
import { UsersServiceProvider } from "./services/Users.service";
import { UsersRoutes } from "./UsersRoutes";

export const Users = () => {
  return (
    <>
      <UsersServiceProvider>
        <UsersFacadeProvider>
          <UsersRoutes></UsersRoutes>
        </UsersFacadeProvider>
      </UsersServiceProvider>
    </>
  );
};
